/**
 * IVD Urbanisme — Premium Animations v4
 * Scroll reveal, stagger, compteurs, particules, typewriter, accordéons…
 * — Idempotent : ré-exécutable sans double-bind (éditeur de thème Shopify)
 * — Respecte prefers-reduced-motion
 * — Particules : multi-canvas (classe OU id), pause hors écran / onglet caché
 */
(function () {
  'use strict';

  var IVD = window.IVDAnimations || {};
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var animEnabled = document.documentElement.getAttribute('data-ivd-anim') !== 'off';

  /* Marqueur "déjà initialisé" par élément et par module */
  function bound(el, key) {
    var attr = 'data-ivd-bound-' + key;
    if (el.hasAttribute(attr)) return true;
    el.setAttribute(attr, '1');
    return false;
  }


  /* =====================================================
     0. FILET DE SÉCURITÉ
     L'IntersectionObserver ne se déclenche pas dans un onglet
     d'arrière-plan, chez certains robots d'indexation ni dans
     quelques navigateurs intégrés. Ce balayage garantit qu'aucun
     bloc ne reste invisible, quoi qu'il arrive.
  ===================================================== */
  IVD.sweep = function () {
    var vh = window.innerHeight || 800;
    var marge = vh * 1.15;
    document.querySelectorAll('[data-ivd-reveal]:not(.ivd-visible)').forEach(function (el) {
      if (el.getBoundingClientRect().top < marge) el.classList.add('ivd-visible');
    });
    document.querySelectorAll('[data-ivd-stagger]').forEach(function (c) {
      if (c.getBoundingClientRect().top >= marge) return;
      var delay = parseInt(c.dataset.ivdStaggerDelay, 10) || 70;
      c.querySelectorAll('[data-ivd-stagger-child]:not(.ivd-visible)').forEach(function (child, i) {
        setTimeout(function () { child.classList.add('ivd-visible'); }, i * delay);
      });
    });
  };

  IVD.revealAll = function () {
    document.querySelectorAll('[data-ivd-reveal], [data-ivd-stagger-child], .ivd-divider-animated').forEach(function (el) {
      el.classList.add('ivd-visible');
    });
  };

  /* =====================================================
     1. SCROLL REVEAL (IntersectionObserver)
  ===================================================== */
  IVD.initReveal = function () {
    var els = document.querySelectorAll('[data-ivd-reveal]');
    if (reduceMotion || !animEnabled || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('ivd-visible'); });
      return;
    }
    /* Un élément plus grand que l'écran ne peut jamais atteindre un ratio
       de 10 % : on le révèle dès qu'un pixel entre dans le viewport. */
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var tall = e.boundingClientRect.height > window.innerHeight * 0.6;
        if (tall || e.intersectionRatio >= 0.1) {
          e.target.classList.add('ivd-visible');
          if (e.target.dataset.once !== 'false') io.unobserve(e.target);
        }
      });
    }, { threshold: [0, 0.1], rootMargin: '0px 0px -60px 0px' });

    els.forEach(function (el) {
      if (el.classList.contains('ivd-visible')) return;
      if (bound(el, 'reveal')) return;
      el.classList.add('ivd-reveal-init');
      io.observe(el);
    });
  };

  /* =====================================================
     2. STAGGER CHILDREN
  ===================================================== */
  IVD.initStagger = function () {
    var all = document.querySelectorAll('[data-ivd-stagger-child]');
    if (reduceMotion || !animEnabled || !('IntersectionObserver' in window)) {
      all.forEach(function (el) { el.classList.add('ivd-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var tall = e.boundingClientRect.height > window.innerHeight * 0.6;
        if (!tall && e.intersectionRatio < 0.08) return;
        var children = e.target.querySelectorAll('[data-ivd-stagger-child]');
        var delay = parseInt(e.target.dataset.ivdStaggerDelay, 10) || 70;
        children.forEach(function (child, i) {
          setTimeout(function () { child.classList.add('ivd-visible'); }, i * delay);
        });
        io.unobserve(e.target);
      });
    }, { threshold: [0, 0.08], rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('[data-ivd-stagger]').forEach(function (el) {
      if (bound(el, 'stagger')) return;
      el.querySelectorAll('[data-ivd-stagger-child]').forEach(function (c) {
        if (!c.classList.contains('ivd-visible')) c.classList.add('ivd-stagger-init');
      });
      io.observe(el);
    });
  };

  /* =====================================================
     3. COMPTEURS ANIMÉS
  ===================================================== */
  IVD.initCounters = function () {
    var els = document.querySelectorAll('[data-ivd-counter]');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) {
        el.textContent = (el.dataset.ivdCounterPrefix || '') + el.dataset.ivdCounter + (el.dataset.ivdCounterSuffix || '');
      });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          IVD._animateCounter(e.target);
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.3 });
    els.forEach(function (el) {
      if (bound(el, 'counter')) return;
      io.observe(el);
    });
  };

  IVD._animateCounter = function (el) {
    var target = parseFloat(el.dataset.ivdCounter);
    if (isNaN(target)) return;
    var suffix = el.dataset.ivdCounterSuffix || '';
    var prefix = el.dataset.ivdCounterPrefix || '';
    var duration = parseInt(el.dataset.ivdCounterDuration, 10) || 1800;
    var decimals = (String(target).split('.')[1] || '').length;
    var start = performance.now();
    var easeOut = function (t) { return t === 1 ? 1 : 1 - Math.pow(2, -10 * t); };
    var update = function (now) {
      var p = Math.min((now - start) / duration, 1);
      el.textContent = prefix + (easeOut(p) * target).toFixed(decimals) + suffix;
      if (p < 1) requestAnimationFrame(update);
    };
    requestAnimationFrame(update);
  };

  /* =====================================================
     4. PARALLAX (désactivé si reduced motion)
  ===================================================== */
  IVD.initParallax = function () {
    if (reduceMotion || !animEnabled) return;
    var elements = document.querySelectorAll('[data-ivd-parallax]');
    if (!elements.length || IVD._parallaxBound) return;
    IVD._parallaxBound = true;
    var ticking = false;
    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        document.querySelectorAll('[data-ivd-parallax]').forEach(function (el) {
          var speed = parseFloat(el.dataset.ivdParallax) || 0.15;
          var rect = el.getBoundingClientRect();
          var centerOffset = rect.top + rect.height / 2 - window.innerHeight / 2;
          el.style.transform = 'translateY(' + (centerOffset * speed) + 'px)';
        });
        ticking = false;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  };

  /* =====================================================
     5. BOUTONS MAGNÉTIQUES
  ===================================================== */
  IVD.initMagnetic = function () {
    if (reduceMotion || !animEnabled) return;
    document.querySelectorAll('[data-ivd-magnetic]').forEach(function (el) {
      if (bound(el, 'magnetic')) return;
      el.addEventListener('mousemove', function (e) {
        var rect = el.getBoundingClientRect();
        var strength = parseFloat(el.dataset.ivdMagnetic) || 0.3;
        var dx = (e.clientX - rect.left - rect.width / 2) * strength;
        var dy = (e.clientY - rect.top - rect.height / 2) * strength;
        el.style.transform = 'translate(' + dx + 'px, ' + dy + 'px)';
      });
      el.addEventListener('mouseleave', function () {
        el.style.transition = 'transform 0.4s cubic-bezier(0.22,1,0.36,1)';
        el.style.transform = '';
        setTimeout(function () { el.style.transition = ''; }, 400);
      });
    });
  };

  /* =====================================================
     6. EFFET TYPEWRITER
  ===================================================== */
  IVD.initTypewriter = function () {
    document.querySelectorAll('[data-ivd-typewriter]').forEach(function (el) {
      if (bound(el, 'typewriter')) return;
      var words = (el.dataset.ivdTypewriter || '').split('|').filter(function (w) { return w.trim(); });
      if (!words.length) return;

      if (reduceMotion || !animEnabled) {
        el.textContent = words[0];
        return;
      }

      var wi = 0, ci = 0, deleting = false;
      /* le premier libellé est rendu côté serveur : on repart de lui */
      var seed = (el.textContent || '').trim();
      if (seed && seed === words[0]) { ci = seed.length; deleting = true; }
      var speed = parseInt(el.dataset.ivdTypewriterSpeed, 10) || 80;

      if (!el.nextElementSibling || !el.nextElementSibling.classList.contains('ivd-typewriter-cursor')) {
        var cursor = document.createElement('span');
        cursor.className = 'ivd-typewriter-cursor';
        cursor.setAttribute('aria-hidden', 'true');
        el.parentNode.insertBefore(cursor, el.nextSibling);
      }

      var tick = function () {
        if (!el.isConnected) return; /* section supprimée dans l'éditeur */
        var word = words[wi];
        if (!deleting) {
          el.textContent = word.slice(0, ++ci);
          if (ci === word.length) {
            deleting = true;
            setTimeout(tick, 1800);
            return;
          }
        } else {
          el.textContent = word.slice(0, --ci);
          if (ci === 0) {
            deleting = false;
            wi = (wi + 1) % words.length;
          }
        }
        setTimeout(tick, deleting ? speed / 2 : speed);
      };
      setTimeout(tick, ci > 0 ? 2200 : 0);
    });
  };

  /* =====================================================
     7. ACCORDÉONS FLUIDES
  ===================================================== */
  IVD.initAccordion = function () {
    document.querySelectorAll('[data-ivd-accordion]').forEach(function (container) {
      var multiOpen = container.dataset.ivdAccordion === 'multi';
      container.querySelectorAll('[data-ivd-accordion-trigger]').forEach(function (trigger) {
        if (bound(trigger, 'accordion')) return;
        trigger.addEventListener('click', function () {
          var item = trigger.closest('[data-ivd-accordion-item]');
          if (!item) return;
          var body = item.querySelector('[data-ivd-accordion-body]');
          var isOpen = trigger.classList.contains('ivd-open');

          if (!multiOpen) {
            container.querySelectorAll('[data-ivd-accordion-trigger].ivd-open').forEach(function (t) {
              if (t === trigger) return;
              var it = t.closest('[data-ivd-accordion-item]');
              var b = it && it.querySelector('[data-ivd-accordion-body]');
              t.classList.remove('ivd-open');
              t.setAttribute('aria-expanded', 'false');
              if (b) { b.style.maxHeight = '0'; b.classList.remove('ivd-open'); }
            });
          }

          if (!isOpen) {
            trigger.classList.add('ivd-open');
            trigger.setAttribute('aria-expanded', 'true');
            if (body) {
              body.classList.add('ivd-open');
              body.style.maxHeight = body.scrollHeight + 'px';
            }
          } else {
            trigger.classList.remove('ivd-open');
            trigger.setAttribute('aria-expanded', 'false');
            if (body) { body.style.maxHeight = '0'; body.classList.remove('ivd-open'); }
          }
        });
      });
    });
  };

  /* =====================================================
     8. PARTICULES CANVAS
     — supporte plusieurs canvas : .ivd-particles-canvas ou #ivd-particles-canvas
     — pause hors écran + onglet masqué, couleur = --ivd-accent-rgb
  ===================================================== */
  IVD.initParticles = function () {
    if (reduceMotion || !animEnabled) return;
    /* Sur mobile, les points décoratifs se superposent au texte des heros
       (colonnes étroites) et coûtent de la batterie : on les désactive. */
    if (window.innerWidth <= 640) return;
    if (document.documentElement.getAttribute('data-ivd-particles') === 'off') return;
    var canvases = document.querySelectorAll('canvas.ivd-particles-canvas, canvas#ivd-particles-canvas');
    if (!canvases.length) return;

    var accentRgb = (getComputedStyle(document.documentElement).getPropertyValue('--ivd-accent-rgb') || '29,122,105').trim();

    canvases.forEach(function (canvas) {
      if (bound(canvas, 'particles')) return;
      canvas.setAttribute('aria-hidden', 'true');
      var ctx = canvas.getContext('2d');
      if (!ctx) return;
      var particles = [];
      var N = window.innerWidth < 768 ? 22 : 42;
      var visible = false;
      var rafId = null;

      var resize = function () {
        canvas.width = canvas.offsetWidth || 0;
        canvas.height = canvas.offsetHeight || 0;
      };
      resize();
      window.addEventListener('resize', resize, { passive: true });

      for (var i = 0; i < N; i++) {
        particles.push({
          x: Math.random() * (canvas.width || 800),
          y: Math.random() * (canvas.height || 400),
          r: Math.random() * 2.5 + 0.8,
          dx: (Math.random() - 0.5) * 0.4,
          dy: (Math.random() - 0.5) * 0.4,
          o: Math.random() * 0.4 + 0.1
        });
      }

      var draw = function () {
        if (!visible || document.hidden || !canvas.isConnected) { rafId = null; return; }
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        particles.forEach(function (p) {
          ctx.beginPath();
          ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
          ctx.fillStyle = 'rgba(' + accentRgb + ',' + p.o + ')';
          ctx.fill();
          p.x += p.dx; p.y += p.dy;
          if (p.x < 0 || p.x > canvas.width) p.dx *= -1;
          if (p.y < 0 || p.y > canvas.height) p.dy *= -1;
        });
        rafId = requestAnimationFrame(draw);
      };
      var start = function () { if (!rafId && visible && !document.hidden) rafId = requestAnimationFrame(draw); };

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            visible = e.isIntersecting;
            if (visible) start();
          });
        }, { threshold: 0 }).observe(canvas);
      } else {
        visible = true;
        start();
      }
      document.addEventListener('visibilitychange', start);
    });
  };

  /* =====================================================
     9. BARRE DE PROGRESSION DE LECTURE
  ===================================================== */
  IVD.initScrollProgress = function () {
    var bar = document.getElementById('ivd-scroll-progress');
    if (!bar || bound(bar, 'progress')) return;
    window.addEventListener('scroll', function () {
      var scrolled = window.scrollY;
      var total = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.width = (total > 0 ? (scrolled / total) * 100 : 0) + '%';
    }, { passive: true });
  };

  /* =====================================================
     10. TILT 3D SUR CARTES
  ===================================================== */
  IVD.initTilt = function () {
    if (reduceMotion || !animEnabled) return;
    document.querySelectorAll('[data-ivd-tilt]').forEach(function (el) {
      if (bound(el, 'tilt')) return;
      el.addEventListener('mousemove', function (e) {
        var rect = el.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;
        var intensity = parseFloat(el.dataset.ivdTilt) || 8;
        el.style.transform = 'perspective(800px) rotateY(' + (x * intensity) + 'deg) rotateX(' + (-y * intensity) + 'deg) scale(1.02)';
      });
      el.addEventListener('mouseleave', function () {
        el.style.transform = '';
        el.style.transition = 'transform 0.5s cubic-bezier(0.22,1,0.36,1)';
        setTimeout(function () { el.style.transition = ''; }, 500);
      });
    });
  };

  /* =====================================================
     11. OMBRE DU HEADER STICKY
  ===================================================== */
  IVD.initStickyHeader = function () {
    if (IVD._stickyBound) return;
    var header = document.querySelector(
      '.shopify-section-group-header-group, .site-header, .header-wrapper, header[class]'
    );
    if (!header) return;
    IVD._stickyBound = true;
    var update = function () {
      header.classList.toggle('header-wrapper--scrolled', window.scrollY > 60);
      header.classList.toggle('ivd-scrolled', window.scrollY > 60);
    };
    window.addEventListener('scroll', update, { passive: true });
    update();
  };

  /* =====================================================
     12. FONDU DES IMAGES LAZY
  ===================================================== */
  IVD.initLazyImages = function () {
    document.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
      if (img.complete) {
        img.classList.add('ivd-loaded');
      } else if (!bound(img, 'lazy')) {
        img.addEventListener('load', function () { img.classList.add('ivd-loaded'); });
        img.addEventListener('error', function () { img.classList.add('ivd-loaded'); });
      }
    });
  };

  /* =====================================================
     13. ANCRES FLUIDES
  ===================================================== */
  IVD.initSmoothAnchors = function () {
    document.querySelectorAll('a[href^="#"]').forEach(function (a) {
      if (bound(a, 'anchor')) return;
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href').slice(1);
        var target = id ? document.getElementById(id) : null;
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        }
      });
    });
  };

  /* =====================================================
     14. PARALLAX IMAGE AU SURVOL
  ===================================================== */
  IVD.initImageHoverParallax = function () {
    if (reduceMotion || !animEnabled) return;
    document.querySelectorAll('[data-ivd-img-parallax]').forEach(function (wrapper) {
      if (bound(wrapper, 'imgparallax')) return;
      var img = wrapper.querySelector('img');
      if (!img) return;
      wrapper.addEventListener('mousemove', function (e) {
        var rect = wrapper.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;
        img.style.transform = 'scale(1.06) translate(' + (x * 8) + 'px, ' + (y * 8) + 'px)';
      });
      wrapper.addEventListener('mouseleave', function () {
        img.style.transform = '';
        img.style.transition = 'transform 0.5s cubic-bezier(0.22,1,0.36,1)';
        setTimeout(function () { img.style.transition = ''; }, 500);
      });
    });
  };

  /* =====================================================
     15. SÉPARATEURS ANIMÉS
  ===================================================== */
  IVD.initDividers = function () {
    var els = document.querySelectorAll('.ivd-divider-animated');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('ivd-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('ivd-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.2 });
    els.forEach(function (el) {
      if (bound(el, 'divider')) return;
      io.observe(el);
    });
  };

  /* =====================================================
     INIT
  ===================================================== */
  function init() {
    IVD.initReveal();
    IVD.initStagger();
    IVD.initCounters();
    IVD.initParallax();
    IVD.initMagnetic();
    IVD.initTypewriter();
    IVD.initAccordion();
    IVD.initParticles();
    IVD.initScrollProgress();
    IVD.initTilt();
    IVD.initStickyHeader();
    IVD.initLazyImages();
    IVD.initSmoothAnchors();
    IVD.initImageHoverParallax();
    IVD.initDividers();
  }

  var sweepTicking = false;
  function onScrollSweep() {
    if (sweepTicking) return;
    sweepTicking = true;
    requestAnimationFrame(function () { IVD.sweep(); sweepTicking = false; });
  }

  function boot() {
    init();
    IVD.sweep();
    if (!IVD._sweepBound) {
      IVD._sweepBound = true;
      window.addEventListener('scroll', onScrollSweep, { passive: true });
      window.addEventListener('resize', onScrollSweep, { passive: true });
      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'visible') IVD.sweep();
      });
      window.addEventListener('load', function () { IVD.sweep(); });
      /* dernier recours : au bout de 4 s, plus rien ne reste masqué */
      setTimeout(IVD.sweep, 1200);
      setTimeout(IVD.revealAll, 4000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Ré-init dans l'éditeur de thème (les gardes bound() évitent tout double-bind) */
  if (typeof Shopify !== 'undefined' && Shopify.designMode && !IVD._designModeBound) {
    IVD._designModeBound = true;
    document.addEventListener('shopify:section:load', function () { init(); IVD.sweep(); });
  }

  window.IVDAnimations = IVD;
})();
